// "Ask Ogma anything" from inside a page (Connect package 5): a page hands a question to the chat drawer that the
// layout owns (components/Layout.tsx), so asking about performance on Sales performance and in the Ask bar is the same
// assistant, the same figures and the same business. Pinning a chart from the drawer tells the Sales performance page
// to reload its pins (PINS_CHANGED).
import { createContext, useContext } from "react";

/** Opens the chat drawer and sends the question (empty: just opens it). */
export type AskOgma = (question: string) => void;

export const AskOgmaContext = createContext<AskOgma | null>(null);

/** The layout's ask, or null outside the signed-in layout (the page then says the assistant is not here). */
export const useAskOgma = (): AskOgma | null => useContext(AskOgmaContext);

/** Fired on window after a chart is pinned from the chat drawer. */
export const PINS_CHANGED = "ogma:performance-pins-changed";
